<template>


		<v-container fluid no-padding class="about fill-height">
			<v-row
				no-gutters
			
				align="stretch"
				justify="start"

				class="fill-height"
			>
				<v-col
			
				
					:md=5
					:sm=5
					cols=12
				>
				
							<v-img
								
								eager
								min-height=100%
								class="white--text profile-img"
								src="/images/profile.jpg">

							</v-img>
			
				
				</v-col>
				
			<v-col
	
				:md=7
				:sm=7
				cols=12
				id="intro"
			
			>

				<v-spacer></v-spacer>
				<div class="main textLight--text" >
					<span class="textLight--text" id="hello">Hello! I'm Magnus Haaland</span>
					<br/><br/>
					I am currently enrolled in the Interactive Media Technology masters programme at KTH, specializing in Physical Interaction Design. 
					At the moment I am writing my thesis on interactive music.
					<br/><br/>
					
				</div>
				<v-spacer></v-spacer>
				<span class="text--text" id="statement">Here are some of my projects. </span>
			</v-col>
			
		</v-row>

		</v-container>
			

</template>

<script>
export default {
  name: 'About',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#profile-img{
   -webkit-filter: grayscale(100%) opacity(0.8);
   -moz-filter: grayscale(100%)  opacity(0.8);
   filter: grayscale(100%)  opacity(0.8);
	
   transition: all 1s ease;
}
#profile-img:hover{
	 -webkit-filter: grayscale(0%);
   -moz-filter: grayscale(0%);
   filter: grayscale(0%);
}

.footer{
	margin: 0; 
}
.no-padding {
	padding:0;
}
span{
	white-space: pre-wrap;
}
#intro{
	
	padding: 2em;
	padding-right:3em;
	display:flex; 
	flex-direction: column;
	justify-content: space-around;

	flex-grow: 4;
}
#hello{
	text-transform: uppercase;
	font-weight: 600;

	font-size: 0.85em;
}
#statement{
	align-self:flex-end;
	font-weight: 500;
	font-size: 1.1em;
}
.profile-img{
	margin-bottom:0px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.main{
	font-size: 1.3em;
}
</style>
